import { Injectable, OnInit } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Task } from '../models/user.model';

@Injectable()
export class ChannelService implements OnInit {
    static source: BehaviorSubject<string> = new BehaviorSubject('');
    static nexturl: BehaviorSubject<string> = new BehaviorSubject('');
    static token: BehaviorSubject<string> = new BehaviorSubject('');
    static username: BehaviorSubject<string> = new BehaviorSubject('');
    static task: BehaviorSubject<Task> = new BehaviorSubject(Task.NONE);
    constructor() { }

    ngOnInit() { }

    setSource(source: string) {
        var sources = new Set(['bennet', 'drive', 'tablet', 'totem', 'bennet-new', 'drive-new', 'tablet-new', 'totem-new', 'veronesi', 'app','instacook']);
        var src = sources.has(source) ? source : ("tablet" || "tablet-new")
        ChannelService.source.next(src);
        if (src === 'drive' || src === 'drive-new')
            document.title = 'BennetDrive - Profilo clienti';
        $('body').addClass('theme-' + src);
        return src;
    }
    setNextUrl(nexturl: string,source) {
        if(!nexturl){
            nexturl = source=='drive'?'https://www.bennetdrive.it/CommerceCore':'https://www.bennet.com';
        }
        ChannelService.nexturl.next(nexturl);
       // ChannelService.nexturl.next(nexturl.concat("?registrationSuccess=true"));
    }
    setToken(token: string) {
        ChannelService.token.next(token);
    }
    setUserName(username: string) {
        ChannelService.username.next(username);
    }
    setTask(task: Task) {
        ChannelService.task.next(task);
    }
    getTask(): Observable<Task> {
        return ChannelService.task.asObservable();
    }
    getSource(): Observable<string> {
        return ChannelService.source.asObservable();
    }
    getNextUrl(): Observable<string> {
        return ChannelService.nexturl.asObservable();
    }
    getToken(): Observable<string> {
        return ChannelService.token.asObservable();
    }
    getUserName(): Observable<string> {
        return ChannelService.username.asObservable();
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/services/channel.service.ts